function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M90.319 27.892H80.104l-3.392-10.215H42.675l-3.392 10.215H29.068a3.394 3.394 0 00-3.392 3.392v66.67a3.394 3.394 0 003.393 3.391h61.25a3.394 3.394 0 003.392-3.392v-66.67a3.394 3.394 0 00-3.392-3.391z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.105 47.62l2.261-7.837-5.653-8.5-5.653 8.5 2.261 7.837-6.823 33.412L59.713 94.64l10.215-13.607-6.823-33.412z",
  fill: "#00BAC3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.713 86.14a1.73 1.73 0 001.716-1.716 1.73 1.73 0 00-1.716-1.716c-.935 0-1.715.741-1.715 1.716.039.936.78 1.715 1.715 1.715z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M81.313 26.215l-3.003-9.006v-.04A1.71 1.71 0 0076.712 16H42.675c-.74 0-1.364.468-1.598 1.17v.039l-3.002 9.006h-8.968c-2.807 0-5.107 2.3-5.107 5.107v66.67c0 2.807 2.3 5.107 5.107 5.107h61.25c2.808 0 5.108-2.3 5.108-5.107v-66.67c0-2.807-2.3-5.107-5.107-5.107h-9.046zm-21.6 2.924L47.55 19.392h24.328l-12.164 9.747zm-16.141-8.577l13.88 11.111-4.796 7.174-11.384-11.385 2.3-6.9zm14.153 28.773h4.015l6.355 31.307-8.382 11.19-8.382-11.19 6.394-31.307zm4.132-3.392h-4.25l-1.676-5.848 3.821-5.732 3.82 5.732-1.715 5.848zm4.952-7.096l-4.796-7.174 13.88-11.111 2.3 6.9L66.81 38.847zm25.186-7.564v66.67a1.73 1.73 0 01-1.715 1.715H29.068a1.73 1.73 0 01-1.715-1.715v-66.67c0-.935.78-1.715 1.715-1.715h9.513l13.1 13.1c.39.39.975.585 1.56.468l1.326 4.522-6.745 33.023c-.078.468 0 .975.312 1.365l10.175 13.568c.195.272.468.468.741.584.741.273 1.56.04 1.989-.545l10.215-13.607c.272-.39.39-.897.311-1.365L64.86 47.697l1.326-4.522a1.733 1.733 0 001.56-.468l13.1-13.1h9.513c.896 0 1.637.74 1.637 1.676z",
  fill: "#384B51"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M61.39 77.523V63.02c0-.858-.624-1.599-1.443-1.755a1.696 1.696 0 00-1.95 1.677v14.62c0 1.014.898 1.833 1.95 1.677.819-.117 1.443-.858 1.443-1.716z",
  fill: "#fff"
});

function SvgAttireCustom(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgAttireCustom;